export default __webpack_public_path__ + "static/media/Sage's Straps of the Purple Sun.1781c585.jpg";